import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import GlobalContextProvider from '../../src/components/Context';

export const wrapRootElement = ({ element }) => {
  console.info('theme', theme);
  return <GlobalContextProvider><ThemeProvider theme={theme}>{element}</ThemeProvider></GlobalContextProvider>;
};
